import React, { useState, useEffect, useRef } from "react";
import { MSG } from "../constants/toastMessages";
import { IoCloseOutline } from "react-icons/io5";
import { toast } from 'react-toastify';
import { apiCallingPost } from "../api/services"

function TagDirectoryDelete(props) {

    const handleDelete = async () => {
        let postData = {
            tag: props.selectTag,
        }
        try {
            const response = await apiCallingPost("api/tag_directory/delete_tags", postData);
            const { data } = response;
            if (data.success === "1") {
                toast.success(MSG.tagDeleted);
                setTimeout(() => {
                    props.TagDirectoryList()
                    props.setTagDeletePopup(false)
                }, 1000);
            }
        } catch (error) {
            console.error("Error fetching tag directory:", error);

        }
    }
    return (
        <div className="modal-admin-wrapper">
            <div className={`modal-ad-popup ${props.videoDetails.length > 1 ? `modal-lg` : `modal-md`}`} ref={props.wrapperRef}>
                <div className="modal-innerpopup ">
                    <div className="modal-headdiv d-flex justify-content-between">
                        <h5 className="modal-head">  Delete Tag</h5>
                        <span className="closeBtn"><IoCloseOutline size={32} onClick={() => props.cancelPopup()} /></span>
                    </div>
                    <div className="modal-admin-body">
                        <div className="col-12">
                            <div className="form_div mb-3">
                                {props.videoDetails.length > 1 ? (
                                    <div className='table-responsive'>
                                        <div className="text-center mb-3">Warning: Deleting the tag(s) will affect the related tags and associated media files:</div>
                                        <table className="table table-bordered admin-list-table">
                                            <thead>
                                                <tr>
                                                    <th className='text-center' style={{ minWidth: "200px" }}>Tag Name</th>
                                                    <th className=''>Video Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.videoDetails.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{data.tag_name}</td>
                                                        <td className="tag-listing gap-1 justify-content-start">
                                                            {data.videonames.map((tags, index) => (
                                                                <div key={index} className="tag-list">{tags}</div>
                                                            ))}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <>
                                        <div className="text-center mb-3">Warning: Deleting the <strong>{props.videoDetails?.[0]?.tag_name}</strong> will affect the related tags and associated media files:</div>
                                        {/* <div className="text-center mb-3">Warning: Deleting <strong>{props.videoDetails?.[0]?.tag_name}</strong> will also affect the associated media:</div> */}
                                        <div className="tag-listing tag-listing-popup mb-3">
                                            {props.videoDetails?.[0]?.videonames.map((video, index) => (
                                                <div key={index} className="tag-list">
                                                    {video}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                                <div className="text-center mt-3">Do you want to proceed?</div>
                            </div>
                            <div className={`d-flex align-items-center gap-2 ${props.videoDetails.length > 1 ? `w-75 m-auto` : ``}`}>
                                <button
                                    type="button"
                                    className="accept-all-btn w-100 py-2 accept-all-gray"
                                    onClick={() => props.cancelPopup()}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="accept-all-btn w-100 py-2"
                                    onClick={() => handleDelete()}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TagDirectoryDelete;
